import { useState } from "react";

import DashboardHeader from "./DashboardHeader";
import DashboardCards from "./DashboardCards";
import DashboardCharts from "./DashboardCharts";
import DashboardTable from "./DashboardTable";
import DashboardInsights from "./DashboardInsights";
import DashboardAlerts from "./DashboardAlerts";

import AIPanel from "./AIPanel";
import AIToggleButton from "./AIToggleButton";

import { apiList } from "../../helpers/apiList";
import { axiosPostApi } from "../../helpers/interceptorServices";
import AIAnalyzing from "./AIAnalyzing";

const AIDashboard = () => {

    const [dashboard, setDashboard] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");
    const [history, setHistory] = useState([]);
    const [panelOpen, setPanelOpen] = useState(true);
    const [selectedHistoryId, setSelectedHistoryId] = useState(null);

    const fetchAIDashboardData = async (prompt) => {
      try {
        setLoading(true);
        setError("");
        
        const response = await axiosPostApi(
            apiList.AI_DASHBOARD,
            {
                prompt
            }
        );

            const dashboardData = response.data;

            setHistory((prev) => {
              const filtered = prev.filter(
                (item) => item.text.toLowerCase() !== prompt.toLowerCase()
              );
            
              return [
                {
                  id: Date.now(),
                  text: prompt,
                  title: dashboardData.title,
                  createdAt: new Date().toISOString(),
                  dashboard: dashboardData,
                },
                ...filtered,
              ];
            });
            setDashboard(response.data);
        } catch {
            setError("Something went wrong");
        } finally {
            setLoading(false);
        }
    };

    const handleHistoryClick = (item) => {
      setLoading(true);
    
      setTimeout(() => {
        setSelectedHistoryId(item.id);
        setDashboard(item.dashboard);
        setLoading(false);
      }, 400);
    };

    return (
        <div className="relative flex flex-col bg-gray-100 h-screen">
  <div
    className={`transition-all duration-300 ${
      panelOpen ? "w-[calc(100%-360px)]" : "w-full"
    }`}
  >
    {dashboard && (
      <>
        {/* Sticky Header */}
        <div className="sticky top-0 z-20 bg-gray-100 px-6 pt-6 pb-4 border-b">
          <DashboardHeader
            title={dashboard.title}
            subtitle={dashboard.subtitle}
          />
        </div>

        {/* Scrollable Content */}
        <div className="h-[calc(100vh-110px)] overflow-y-auto p-6 pt-4 custom-scrollbar">
          {loading ? (
            <AIAnalyzing />
          ) : (
            <div className="space-y-6">
              <DashboardCards cards={dashboard.cards} />
              <DashboardCharts charts={dashboard.charts} />
              <DashboardTable tables={dashboard.tables} />
              <DashboardInsights insights={dashboard.insights} />
              <DashboardAlerts alerts={dashboard.alerts} />
            </div>
          )}
        </div>
      </>
    )}

    {loading && !dashboard && (
      <div className="h-[calc(100vh-110px)] flex items-center justify-center">
        <AIAnalyzing />
      </div>
    )}
  </div>

  <AIToggleButton
    open={panelOpen}
    onClick={() => setPanelOpen(!panelOpen)}
  />

  <AIPanel
    open={panelOpen}
    loading={loading}
    history={history}
    onSubmit={fetchAIDashboardData}
    onHistorySelect={handleHistoryClick}
    selectedHistoryId={selectedHistoryId}
  />
</div>
    );
};

export default AIDashboard;